<template>
	<div>
		<div v-if="this.category" style="background:var(--grey-4);padding:5px;margin-bottom:5px;border-radius: 5px;"
			:title="this.category.search" class="flexcenter link"
			@click="this.$emit('searchCategorySelected', this.category); console.log('FP: Category: ', category )">
			<div>

				<b>{{ this.category.name }}</b><br />


				<span style="color:grey;margin-left:0px;font-size:85%;">{{ this.categoryPath }}</span>

			</div>

			<b style="flex-grow:1;">&nbsp;</b>
			<div style="background:var(--grey-5);padding:3px;border-radius: 5px;"> {{ productCount }}</div>
			<Icon v-if="!this.isOnProductListPage()" fileName="w3_chevron_right_dark"
				style="height:15px;width:10px;margin-left:5px;" />

		</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '@/store/store';
import { routerMixin } from "@/mixins/routerMixin.js";

//import SelectCategory from '@/components/product/search/SelectCategory.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchCategoryRow",
	components: {},
	mixins: [routerMixin ],
	props:{
		categoryId: Number,
		productCount: String,
		productTypeUrlKey: String,
	},
	data() {
		return {

		};
	},
	computed: {

		categoryPath(){

			if (this.category){
				var label = this.category.path.replace(this.category.name, "");

				label = label.replace("/Boove/", "");
				label = label.replace("/MC/MC Delar/", "");
				label = label.replace("/Cykel/", "");

				return label
			}

			return "--";

		},

		category() {

			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL];
			
			if (categoryModel && categoryModel.categoryList && categoryModel.categoryList) {
				const categoryList = categoryModel.categoryList;

				return categoryList.find(category =>  category.categoryId == this.categoryId )
			}

			return null;

		},

		





	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped></style>